import React from "react";
import { Helmet } from "react-helmet-async";
import "./UserGuide.css";

function ProtectYourself() {

  

  return (

    <div className="user-guide-page">

      {/* SEO META */}
      <Helmet>
        <title>Protect Yourself | Safe Medicine & Online Pharmacy Tips</title>
        <meta
          name="description"
          content="Learn how to protect yourself while buying medicines online. Safety tips, verified pharmacies, and secure medication usage guidelines."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://realgenericshop.com/protect-yourself" />
      </Helmet>

      <div className="user-guide-container">

        <h1 className="user-guide-title">
          Protect Yourself
        </h1>

        <div className="user-guide-content">

          <p>
            Your health and safety are our top priorities.
            Follow these essential guidelines to protect
            yourself while purchasing and using medicines.
          </p>

          <h3>Buy Medicines Safely</h3>

          <ul>

            <li>
              Always purchase from trusted and licensed pharmacies
            </li>

            <li>
              Avoid unknown or unverified online sellers
            </li>

            <li>
              Check product authenticity and packaging
            </li>

          </ul>

          <h3>Check Before Use</h3>

          <ul>

            <li>
              Verify expiry date
            </li>

            <li>
              Read instructions carefully
            </li>

            <li>
              Follow dosage recommended by your doctor
            </li>

          </ul>

          <h3>Online Safety</h3>

          <ul>

            <li>
              Use secure websites (HTTPS)
            </li>

            <li>
              Do not share personal or payment details
              on unknown platforms
            </li>

            <li>
              Keep your account credentials safe
            </li>

          </ul>

          <h3>Consult Professionals</h3>

          <p>
            Always consult a doctor or pharmacist before
            starting any new medication to avoid risks
            and side effects.
          </p>

        </div>

      </div>

    </div>

  );

}

export default ProtectYourself;